var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPillGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 400,
    viewBox: "0 0 206 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 205,
    height: 400,
    rx: 102.5,
    fill: "#5CD17E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 200H205V297.5C205 354.109 159.109 400 102.5 400C45.8908 400 0 354.109 0 297.5V200Z",
    fill: "#7BE89A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPillGreen);
export default __webpack_public_path__ + "static/media/pill_green.3ef82b68ed89984073faa8f5dd9b9ec3.svg";
export { ForwardRef as ReactComponent };